import * as components from "./formily";
import { ElSpace } from "element-plus";
import {
  ISchemaFieldVueFactoryOptions,
  SchemaVueComponents,
  createSchemaField as _createSchemaField,
  DefineComponent,
  ISchemaFieldProps,
  ISchemaMarkupFieldProps,
  ISchemaTypeFieldProps
} from "@formily/vue";

declare type SchemaFieldComponents = {
  SchemaField: DefineComponent<ISchemaFieldProps>;
  SchemaMarkupField: DefineComponent<ISchemaMarkupFieldProps>;
  SchemaStringField: DefineComponent<ISchemaTypeFieldProps>;
  SchemaObjectField: DefineComponent<ISchemaTypeFieldProps>;
  SchemaArrayField: DefineComponent<ISchemaTypeFieldProps>;
  SchemaBooleanField: DefineComponent<ISchemaTypeFieldProps>;
  SchemaDateField: DefineComponent<ISchemaTypeFieldProps>;
  SchemaDateTimeField: DefineComponent<ISchemaTypeFieldProps>;
  SchemaVoidField: DefineComponent<ISchemaTypeFieldProps>;
  SchemaNumberField: DefineComponent<ISchemaTypeFieldProps>;
};

export function createSchemaField<Components extends SchemaVueComponents = SchemaVueComponents>(
  options?: ISchemaFieldVueFactoryOptions<Components>
): SchemaFieldComponents {
  return (_createSchemaField as unknown as typeof _createSchemaField)({
    ...options,
    components: {
      ...(components as unknown as SchemaVueComponents),
      Space: ElSpace,
      ...(options?.components || {})
    }
  });
}
